import { domStorage } from "../_globals"
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import WknSwiper from '../modules/wkn-swiper'

export default class Footer {
  constructor() {
    this.DOM = { 
      el: domStorage.footer,
      footerPartnersSwiper: domStorage.footer.querySelector('.footer-partners .swiper')
    }

    // MatchMedia variable
    this.mm = gsap.matchMedia()
    // Breakpoint
    this.breakpoint = 768
    // Responsive object
    this.responsiveObj = {
      isDesktop: `(min-width: ${this.breakpoint}px)`,
      isMobile: `(max-width: ${this.breakpoint - 1}px)`
    }

    this.setParallax()
    this.setSwiper()
  }

  /**
   * Parallax
   */

  setParallax() {
    this.mm.add(this.responsiveObj, (context) => {
      const { isDesktop } = context.conditions

      if (isDesktop) {
        this.tween = gsap.from(this.DOM.el.children[0], { 
          yPercent: -10, 
          opacity: 0.5, 
          ease: 'none' 
        })

        this.scrollTrigger = new ScrollTrigger({
          trigger: this.DOM.el,
          start: 'top bottom',
          end: 'bottom bottom',
          scrub: true,
          animation: this.tween
        })
      } 
    })
  }

  /**
   * Swiper
   */

  setSwiper() {
    if (!this.DOM.footerPartnersSwiper) return

    this.footerPartnersSwiperModule = new WknSwiper(this.DOM.footerPartnersSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 20
    })
  }

  onResize() {
    ScrollTrigger.refresh()
  }
}